export function removeTypename<T>(
	obj: T | T[] | undefined,
): Omit<T, "__typename"> | Omit<T, "__typename">[] | undefined {
	if (!obj) return obj;

	if (Array.isArray(obj)) {
		// Recursively process arrays
		return obj.map(item => removeTypename(item)) as Omit<T, "__typename">[];
	}

	if (obj instanceof Date) {
		// Return Date objects as-is
		return obj;
	}

	if (typeof obj === "object") {
		// Remove `__typename` and process nested objects
		const newObj = { ...obj };
		if ("__typename" in newObj) delete newObj.__typename;
		return Object.entries(newObj).reduce(
			(acc, [key, value]) => {
				acc[key as keyof Omit<T, "__typename">] = removeTypename(value) as never;
				return acc;
			},
			{} as Omit<T, "__typename">,
		);
	}

	// Return the value as-is for primitives
	return obj;
}
